module.exports = __webpack_public_path__ + "assets/0f6c4eb5555d365456b0a63562971e7e.png";